module.exports = __webpack_public_path__ + "Close/Close-7203ddb8c705784357e71de2e64038d8.svg";